<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="aG" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 172.9 128.6" style="enable-background:new 0 0 172.9 128.6;" xml:space="preserve">
<style type="text/css">
	.st0G{fill:url(#SVGID_1_GMOI);}
	.st1G{fill:url(#SVGID_00000029012837056082208560000011312880847900416384_);}
	.st2G{fill:url(#SVGID_00000093866359683467538180000002566768084245135011_);}
	.st3G{fill:url(#SVGID_00000132075466675391807810000017507509499009587351_);}
</style>
<linearGradient id="SVGID_1_GMOI" gradientUnits="userSpaceOnUse" x1="75.2718" y1="-581.8052" x2="75.2718" y2="-478.9651" gradientTransform="matrix(1 0 0 -1 0 -466.1102)">
	<stop  offset="0" style="stop-color:#0052CC"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</linearGradient>
<path class="st0G" d="M107.2,15.8c-0.3-1.1-1.1-2-2.1-2.5c-1-0.5-2.1-0.6-3.2-0.3l-17.6,5.7c-2.2,0.7-3.4,3.1-2.7,5.3l0.9,2.7
	L37.9,59.6l-17.7,5.8c-1.1,0.3-2,1.1-2.5,2.1c-0.5,1-0.6,2.1-0.2,3.2l10.7,33c0.6,1.8,2.2,2.9,4,2.9c0.4,0,0.8-0.1,1.3-0.2l17.6-5.7
	l9.1,0.1c1.8,8.6,9.5,15.1,18.6,15.1s16.6-6.4,18.5-14.8l9.3,0.1l0.9,2.7c0.3,1.1,1.1,2,2.1,2.5c0.6,0.3,1.2,0.4,1.9,0.4
	c0.4,0,0.9-0.1,1.3-0.2l17.6-5.7c2.2-0.7,3.4-3.1,2.7-5.3L107.2,15.8z M34.9,97l-8.1-25l10.3-3.4l8.1,25C45.2,93.7,34.9,97,34.9,97z
	 M78.8,107.3c-4.4,0-8.2-2.7-9.8-6.6l19.6,0.1C87,104.6,83.2,107.3,78.8,107.3z M53.5,92.2l-4.4-13.6L44.7,65l40.5-29.8l12.4,38.2
	l6.2,19C103.8,92.5,53.5,92.2,53.5,92.2z M114.2,97l-0.5-1.6l0,0l-11.1-34.2L91,25.5l9.6-3.1l23.2,71.5
	C123.8,93.9,114.2,97,114.2,97z"/>
<linearGradient id="SVGID_00000027600303583147959230000014547028643630307720_" gradientUnits="userSpaceOnUse" x1="122.3556" y1="-500.2185" x2="132.3476" y2="-480.9305" gradientTransform="matrix(1 0 0 -1 0 -466.1102)">
	<stop  offset="0" style="stop-color:#0052CC"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</linearGradient>
<path style="fill:url(#SVGID_00000027600303583147959230000014547028643630307720_);" d="M121.3,36.2c0.6,0.3,1.3,0.4,1.9,0.4
	c1.5,0,3-0.8,3.8-2.3l7.6-14.8c1.1-2.1,0.2-4.6-1.8-5.7s-4.6-0.2-5.7,1.8l-7.6,14.8C118.4,32.6,119.3,35.2,121.3,36.2z"/>
<linearGradient id="SVGID_00000088117863559892969280000004110498432163659143_" gradientUnits="userSpaceOnUse" x1="134.1933" y1="-537.7479" x2="153.3454" y2="-546.8679" gradientTransform="matrix(1 0 0 -1 0 -466.1102)">
	<stop  offset="0" style="stop-color:#0052CC"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</linearGradient>
<path style="fill:url(#SVGID_00000088117863559892969280000004110498432163659143_);" d="M152.9,76.2l-14.8-7.6
	c-2.1-1.1-4.6-0.2-5.7,1.8c-1.1,2.1-0.2,4.6,1.8,5.7l14.8,7.6c0.6,0.3,1.3,0.4,1.9,0.4c1.5,0,3-0.8,3.8-2.3
	C155.8,79.7,155,77.2,152.9,76.2z"/>
<linearGradient id="SVGID_00000145751960127603169490000018030763481166983320_" gradientUnits="userSpaceOnUse" x1="133.2233" y1="-517.617" x2="154.0153" y2="-510.329" gradientTransform="matrix(1 0 0 -1 0 -466.1102)">
	<stop  offset="0" style="stop-color:#0052CC"/>
	<stop  offset="1" style="stop-color:#2684FF"/>
</linearGradient>
<path style="fill:url(#SVGID_00000145751960127603169490000018030763481166983320_);" d="M131.6,51.8c0.6,1.8,2.2,2.9,4,2.9
	c0.4,0,0.9-0.1,1.3-0.2l15.8-5.2c2.2-0.7,3.4-3.1,2.7-5.3c-0.7-2.2-3.1-3.4-5.3-2.7l-15.8,5.2C132.2,47.2,131,49.6,131.6,51.8
	L131.6,51.8z"/>
</svg>
